import { AgentAvatar, parseSeed } from '../AgentAvatar';

const SIZE_MAP = {
  sm: 20,
  md: 28,
  lg: 40,
};

/**
 * Agent persona indicator pill — avatar + name + optional config text + edit link.
 * Per wireframe wf-shared.jsx PersonaBadge.
 */
export function PersonaBadge({ name, avatarSeed, config, size = 'md', onEdit }) {
  const { avatarSeed: seed, paletteIndex } = parseSeed(avatarSeed);
  const avatarSize = SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <div className="flex items-center gap-2 bg-slate-800 border border-slate-700 rounded-lg px-3 py-1.5">
      <AgentAvatar
        name={name}
        seed={seed}
        paletteIndex={paletteIndex}
        size={avatarSize}
      />
      <div className="flex flex-col min-w-0">
        <span className="text-sm font-bold text-white truncate">{name}</span>
        {config && (
          <span className="text-xs text-slate-400 font-mono truncate">{config}</span>
        )}
      </div>
      {onEdit && (
        <button
          onClick={onEdit}
          className="text-xs text-slate-400 hover:text-cyan-400 underline ml-2 flex-shrink-0"
        >
          edit
        </button>
      )}
    </div>
  );
}
